import Cookies from "js-cookie";

const COOKIE_OPTIONS: Cookies.CookieAttributes = {
    secure: window.location.protocol === 'https:',
    sameSite: 'strict',
};

export const setSession = (accessToken: string, tokenType: string) => {
    Cookies.set("accessToken", accessToken, COOKIE_OPTIONS);
    Cookies.set("tokenType", tokenType, COOKIE_OPTIONS);
}

export const getSession = () => {
    return {
        accessToken: Cookies.get("accessToken"),
        tokenType: Cookies.get("tokenType"),
    }
}

export type User = {
    id: string;
    email: string;
    name?: string;
    picture_url?: string;
    is_verified: boolean;
    is_active: boolean;
    is_superuser: boolean;
    is_admin: boolean;
    setup_needed: boolean;
    signup_source?: string;
}

export const setUser = (user: User) => {
    Cookies.set("user", JSON.stringify(user), COOKIE_OPTIONS);
}

export const getUser = () => {
    const user = Cookies.get("user");
    if (!user) {
        return null;
    }
    return JSON.parse(user);
}

export const clearSession = () => {
    Cookies.remove("accessToken");
    Cookies.remove("tokenType");
    Cookies.remove("user");
    localStorage.clear();
}
